import React, { useEffect, useMemo, useState } from "react"
import { useParams, useHistory, Link } from "react-router-dom"
import toast from "react-hot-toast"

import { GetProductionLineDetails } from "api/api.service"
import ProductionLineDetailsDailyConfiguration from "./ProductionLineDailyConfigurations"
import ProductionLineDetailsMoulds from "./ProductionLineMoulds"
import ProductionLineDetailsOverrides from "./ProductionLineDetails_Overrides"
import ProductionLineDetailsStages from "./ProductionLineDetails_Stages"
import ProductionLineInfo from "./ProductionLineInfo"
import { APP_ROUTES, getRoute } from "helpers/routeHelpers"
import TabRoute from "components/TabRoutes/TabRoute"

import ProductionLineSkeleton from "./ProductionLineSkeleton/ProductionLineSkeleton"
import TabRouting from "components/TabRoutes/TabRouting"

const TABS_KEYS = {
   OVERRIDES: "overrides",
   STAGES: "stages",
}
const TABS_NAME = {
   OVERRIDES: "Date Overrides",
   STAGES: "Stages",
}

const ProductionLineDetails = () => {
   const { productionLineId } = useParams()
   const history = useHistory()

   const [isLoading, setIsLoading] = useState(true)
   const [productionDetails, setProductionDetails] = useState({})
   useEffect(() => {
      handleFetchProductionDetails()
   }, [])

   const handleFetchProductionDetails = async () => {
      try {
         setIsLoading(true)
         const res = await GetProductionLineDetails(productionLineId)
         setProductionDetails(res)
      } catch (error) {
         history.push(APP_ROUTES.PRODUCTION_LINE_MANAGEMENT)
         toast.error("Production Line does not exist!")
      } finally {
         setIsLoading(false)
      }
   }
   const tabItems = [
      {
         title: "Date Overrides",
         identifier: "1",
         className: "mx-2",
         activeIcon: "",
         icon: "",
         content: (
            <ProductionLineDetailsOverrides
               productionLineId={productionLineId}
               hasOrders={productionDetails?.hasOrders}
            />
         ),
      },
      {
         title: "Stages",
         identifier: "2",
         className: "mx-2",
         activeIcon: "",
         icon: "",
         content: (
            <ProductionLineDetailsStages
               productionLineId={productionLineId}
               hasOrders={productionDetails?.hasOrders}
            />
         ),
      },
   ]

   const tabParams = { productionLineId }

   return (
      <>
         <>
            <div className="mb-2 position-relative">
               <Link
                  to={APP_ROUTES.PRODUCTION_LINE_MANAGEMENT_LISTING}
                  className="navigation-link"
               >
                  {"<"} Back
               </Link>
            </div>
            <ProductionLineInfo
               productionDetails={productionDetails}
               isLoading={isLoading}
               productionLineId={productionLineId}
            />
            <ProductionLineDetailsMoulds
               productionLineId={productionLineId}
               productionMouldDetails={productionDetails?.moulds}
               isLoading={isLoading}
               hasOrders={productionDetails?.hasOrders}
            />
            <hr />
            <ProductionLineDetailsDailyConfiguration
               productionLineId={productionLineId}
               productionDailyConfigurationDetails={
                  productionDetails?.dailyConfigurations
               }
               isLoading={isLoading}
            />
            {/* {isLoading ? (
               <ProductionLineSkeleton />
            ) : (
               <TabRoute tabConfig={TABS_CONFIG} routesConfig={ROUTES_CONFIG} />
            )} */}
            <TabRouting tabItems={tabItems} />
         </>
      </>
   )
}

export default ProductionLineDetails
